export default {
  name: 'fifth',
  data: function() {
    return {

    }
  },
  props: ['landingText', 'next'],
  methods: {
    goToSixth: function() {
      this.$emit('change-component', 'sixth-component')
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/test/subComponents/fifth/fifth.js